import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
const WHATSAPP_URL = 'https://wa.me/77010346443?text=%D1%85%D0%BE%D1%87%D1%83%20%D0%B4%D0%B5%D0%BC%D0%BE%20Meelo';
export function MissionNavbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const prefersReducedMotion = typeof window !== 'undefined' ? window.matchMedia('(prefers-reduced-motion: reduce)').matches : false;
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      setScrollProgress(docHeight > 0 ? Math.min(100, window.scrollY / docHeight * 100) : 0);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navigate = (href: string) => {
    window.history.pushState({}, '', href);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };
  return <>
      <div aria-hidden="true" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      height: 3,
      width: `${scrollProgress}%`,
      background: '#7C4DFF',
      zIndex: 100,
      transition: prefersReducedMotion ? 'none' : 'width 80ms linear',
      pointerEvents: 'none'
    }} data-id="element-25" />
      <div className="fixed top-0 left-0 right-0 z-50 flex justify-center px-4 pt-4 sm:pt-5" data-id="element-26">
        <nav className={`w-full max-w-[1000px] transition-all duration-300 rounded-full border border-white/30 shadow-[0_1px_12px_-2px_rgba(0,0,0,0.06)] backdrop-blur-2xl ${isScrolled ? 'bg-white/30' : 'bg-white/20'}`} data-id="element-27">
          <div className="flex items-center h-14 px-5 sm:px-7" data-id="element-28">
            <button onClick={() => {
            window.location.hash = '';
          }} className="flex-shrink-0 mr-auto md:mr-0" data-id="element-29">
              <img src="https://cdn.magicpatterns.com/uploads/k1HQQhYUAYkCqHQP8zEE8y/meelo_logo_transparent.png" alt="Meelo" className="h-10 sm:h-12 w-auto" data-id="element-30" />
            </button>
            <div className="hidden md:flex items-center justify-end flex-1 gap-1" data-id="element-31">
              <button onClick={() => {
              window.location.hash = '';
            }} className="text-sm font-medium text-gray-700 hover:text-[#7C4DFF] transition-colors whitespace-nowrap px-3 py-1" data-id="element-32">
                О Meelo
              </button>
              <span className="text-sm font-medium text-[#7C4DFF] bg-[#7C4DFF]/10 rounded-full px-3 py-1 whitespace-nowrap" data-id="element-33">
                Миссия
              </span>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="text-sm font-semibold text-[#7C4DFF] hover:text-[#651FFF] transition-colors whitespace-nowrap px-3 py-1 ml-4" data-id="element-34">
                +7 701 034 64 43
              </a>
            </div>
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden text-gray-600 hover:text-[#7C4DFF] transition-colors" data-id="element-35">
              {isMobileMenuOpen ? <X size={22} data-id="element-36" /> : <Menu size={22} data-id="element-37" />}
            </button>
          </div>
          {isMobileMenuOpen && <div className="md:hidden border-t border-white/20 px-5 pb-5 pt-3 flex flex-col gap-1" data-id="element-38">
              <button onClick={() => {
            window.location.hash = '';
            setIsMobileMenuOpen(false);
          }} className="text-sm font-medium text-gray-700 hover:text-[#7C4DFF] py-2 transition-colors text-left" data-id="element-39">
                О Meelo
              </button>
              <span className="text-sm font-medium text-[#7C4DFF] bg-[#7C4DFF]/10 rounded-lg px-3 py-2" data-id="element-40">
                Миссия
              </span>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="text-sm font-semibold text-[#7C4DFF] hover:text-[#651FFF] py-2 transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-41">
                +7 701 034 64 43
              </a>
            </div>}
        </nav>
      </div>
    </>;
}